import clsx from "clsx";
import React, { memo, useEffect, useState } from "react";
import { COLORS } from "../../../core/consts/redesign/commonRedesign";
import { Close } from "../../../core/consts/redesign/icons";
import IconButtonMain from "../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import classes from "./FilterProducts.module.scss";

/* Redesign . text input with filter */
type PropsType = {
  onChange: (val: string) => void;
  label?: string;
  placeholder?: string;
  style?: React.CSSProperties;
  id?: string;
  onClear?: () => void;
  initialFilter?: string;
}

const InputFilterNoOptions = ({
  label,
  placeholder,
  id,
  onChange,
  onClear,
  style,
  initialFilter = ''
}: PropsType) => {
  const [filter, setFilter] = useState(initialFilter);
  const [focus, setFocus] = useState<boolean>(false);

  useEffect(() => {
    if (initialFilter && initialFilter.length > 0) {
      setFilter(initialFilter)
    }
  }, [initialFilter]);

  useEffect(() => {
    if (filter.length >= 3) {
      onChange(filter);
    }
  }, [filter, onChange]);

  const handleChangeFilter = (e: React.ChangeEvent<HTMLInputElement>) => {
    const inputText = e.target.value;
    setFilter(inputText);
  };

  const handleCleanInput = () => {
    setFilter('');
    onClear && onClear();
  }

  return (
    <div className={clsx(classes.inputBox,
      { [classes.inputBoxFocused]: focus })}
      style={style}
      id={id}>
      <label className={classes.label}>{label}</label>
      <div className={classes.rowFlex}>
        <input
          type="text"
          value={filter}
          onChange={handleChangeFilter}
          placeholder={placeholder}
          onFocus={() => setFocus(true)}
          onBlur={() => setFocus(false)}
          className={classes.input}
        />
        {filter.length > 0 &&
          <IconButtonMain
            className={classes.closeIconInn}
            color="noBgGray"
            icon={<Close color={COLORS.gray2} />}
            handleClick={handleCleanInput}
          />}
      </div>
    </div>
  )
}

export default memo(InputFilterNoOptions);
